import { ComponentChildren, h } from "preact";

import classname from "../../../../foundation/utils/classname";

import styles from "./RightPanelCell.module.css";

enum DescriptionDirection {
    Ltr = "ltr",
    Rtl = "rtl"
}

enum Variant {
    Light = "light",
    Dark = "dark"
}

interface Props {
    class?: string;
    variant?: Variant;
    title: ComponentChildren;
    subtitle?: ComponentChildren;
    subtitleIcon?: JSX.Element;
    description?: ComponentChildren;
    rightContent?: ComponentChildren;
    descriptionDirection?: DescriptionDirection;
    displayRightContentOnHover?: boolean;
    titleEllipsis?: boolean;
}

function RightPanelCell({
    class: cssClass,
    variant = Variant.Light,
    title,
    subtitle,
    subtitleIcon,
    description,
    rightContent,
    descriptionDirection = DescriptionDirection.Ltr,
    displayRightContentOnHover = false,
    titleEllipsis = true
}: Props) {
    return (
        <div className={classname(styles.rightPanelCell, cssClass,
            {
                [styles.dark]: variant === Variant.Dark,
                [styles.displayRightContentOnHover]: displayRightContentOnHover
            })}>
            <div className={styles.leftContainer}>
                <span className={classname("body-1", styles.title, {
                    ellipsis: titleEllipsis
                })}>
                    {title}
                </span>
                {subtitle && (
                    <div className={styles.subtitleContainer}>
                        {subtitleIcon}
                        <span className={classname("body-1", styles.subtitle, {
                            ellipsis: titleEllipsis
                        })}>
                            {subtitle}
                        </span>
                    </div>
                )}
                {description && (
                    <span
                        className={classname("caption-2", "ellipsis", styles.description)}
                        dir={descriptionDirection}>
                        {description}
                    </span>
                )}
            </div>
            {rightContent && (
                <div className={styles.rightContainer}>
                    {rightContent}
                </div>
            )}
        </div>
    );
}

export default RightPanelCell;
export { DescriptionDirection, Variant as RightPanelCellVariant };
